import { Table, type TableProps } from 'antd'
import { createGroupBillColumns, type GroupBillTableRow } from './group-bill-columns.tsx'

export function GroupBillsTable<TRow extends GroupBillTableRow>({
  items,
  onBill,
  scrollHeight,
  amountField,
  amountTitle,
  extraColumns = [],
  rowClassName
}: {
  items: TRow[]
  onBill?: (id: number) => void
  scrollHeight?: string
  amountField?: 'outstandingAmountSnapshot' | 'outstandingAmount'
  amountTitle?: string
  extraColumns?: TableProps<TRow>['columns']
  rowClassName?: TableProps<TRow>['rowClassName']
}) {
  return (
    <Table<TRow>
      scroll={{ x: 'max-content', y: scrollHeight }}
      rowKey="billId"
      size="middle"
      pagination={false}
      dataSource={items}
      rowClassName={rowClassName}
      columns={[...createGroupBillColumns<TRow>({ onBill, amountField, amountTitle }), ...extraColumns]}
    />
  )
}
